// removed by extract-text-webpack-plugin
module.exports = {"logo":"_1whYKORePsyDnQ8WcHSyuc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Logo/Logo.styl
// module id = 120
// module chunks = 0